var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48798 0.206299H4.57532C2.04844 0.206299 0 2.25474 0 4.78162V12.4323C0 14.9591 2.04844 17.0076 4.57532 17.0076H12.226C14.7528 17.0076 16.8013 14.9591 16.8013 12.4323H15.3013C15.3013 14.1307 13.9244 15.5076 12.226 15.5076H4.57532C2.87687 15.5076 1.5 14.1307 1.5 12.4323V4.78162C1.5 3.08317 2.87687 1.7063 4.57532 1.7063H6.48798V0.206299Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53162 0.95636H9.35694",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0513 12.4323L16.0513 8.60699",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7041 1.91266L15.0949 4.78165",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1734 9.55415L7.17017 9.62811C7.15774 9.91283 7.39555 10.1451 7.6799 10.1261L7.85878 10.114C9.37545 10.0122 10.8123 9.39729 11.933 8.37033L16.0187 4.62656C16.8948 3.8237 16.9542 2.46259 16.1514 1.58643C15.3485 0.710269 13.9874 0.65084 13.1113 1.45369L9.33873 4.91059C8.02973 6.11006 7.25084 7.7804 7.1734 9.55415Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditrooms);
export default __webpack_public_path__ + "static/media/edit rooms.a6a5ce7b53044a6ca0556efba1eff8bb.svg";
export { ForwardRef as ReactComponent };